module.exports = __webpack_public_path__ + "img/coop0.c6cc645c.png";